import { React, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getToken } from "../../utils";

export default function GetPasswordResetMail() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const token = getToken();

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/stock");
    }
  });

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (isValidEmail) {
      setError("E-mail invalide");
    }

    try {
      const response = await axios.post(
        "http://localhost:8080/api/reset-password",
        {
          email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      // Gérer les erreurs
      if (err.response) {
        // Erreur renvoyée par le backend
        setError(
          err.response.data.message ||
            "Une erreur s'est produite lors de l'envoie du mail"
        );
      } else if (err.request) {
        // Pas de réponse du serveur
        setError("Le serveur ne répond pas. Veuillez réessayer plus tard.");
      } else {
        // Autres erreurs
        setError("Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md max-sm:max-w-sm p-4 sm:p-6 md:p-8 my-16 mx-auto rounded-md z-30 shadow-lg border border-gray-200">
      <form className="space-y-4" onSubmit={handleSubmit}>
        <h5 className="text-3xl font-bold text-gray-900">
          {"Mot de passe oublié?"}
        </h5>
        <p className="">
          Pas de problème. Indiquez-nous simplement votre adresse e-mail, et
          nous vous enverrons un lien de réinitialisation de mot de passe qui
          vous permettra d’en choisir un nouveau.
        </p>
        {error && (
          <p className="text-red-500 bg-red-200 px-4 py-2 rounded-md">
            {error}
          </p>
        )}
        <div>
          <label
            htmlFor="email"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Votre e-mail
          </label>
          <input
            type="email"
            name="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-400 focus:border-amber-400 block w-full p-2.5"
            placeholder="name@company.com"
            required
          />
        </div>
        <div className="">
          <Link
            to="/login"
            className="ms-auto text-sm text-amber-600 hover:underline "
          >
            Se connecter
          </Link>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full text-white bg-amber-600 hover:bg-amber-700 focus:ring-4 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {/* Animate on loading */}
          {loading ? (
            <div className="flex justify-center items-center">
              <div className="w-5 h-5 border-2 border-t-amber-600 rounded-full animate-spin"></div>
            </div>
          ) : (
            "Envoyer le lien de réinitialisation"
          )}
        </button>
      </form>
    </div>
  );
}
